import { apiClient, ApiClient } from "@/lib/api/api-client";

export class SseService {
  private BASE_PATH =
    process.env.API_SSE_ENDPOINT || "http://localhost:8003/realtime";
  private apiVersion = "v1";
  private apiClient: ApiClient = apiClient;
  private token?: string | null;
  constructor() {
    this.assignToken().catch(() => {});
  }

  assignToken = async () => {
    try {
      this.token = await this.apiClient.getToken();
    } catch {
      // Intentionally swallowed: token lookup failure during init must not crash process
    }
  };

  getToken = () => {
    return this.token;
  };
  getSseEndpoint = (candidateId: string) => {
    const topic = `employee_${candidateId}`;
    return `${this.BASE_PATH}/${this.apiVersion}/events?topics=${topic}`;
  };
}

export const sseService = new SseService();
